import { render, staticRenderFns } from "./NosParcs.vue?vue&type=template&id=979280b8&"
import script from "./NosParcs.vue?vue&type=script&lang=js&"
export * from "./NosParcs.vue?vue&type=script&lang=js&"
import style0 from "./NosParcs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports